import React, { useEffect, useState } from "react";
import SettingsInput from "../../Forms/SettingsInput";
import Loader from "../../Loader";
import { GET_USER, SETTING } from "../../../utils/constants/apiUrl";
import { get, post } from "../../../server";
import { loggedInUser } from "../../../utils/store";
import { useAtom } from "jotai";
import showToast from "../../../helpers/showToast";
import person from "../../../assets/images/settings_page_icons/person.svg";
import emailicon from "../../../assets/images/settings_page_icons/email.svg";
import location from "../../../assets/images/settings_page_icons/location.svg";
import jobIcon from "../../../assets/images/settings_page_icons/job.svg";
import ValidateSchema from "../../../helpers/ValidateSchema";
import ProfileSchema from "../../../utils/SchemasValidation/ProfileSchema";
import _ from "lodash";
import PhoneInput from "react-phone-input-2";
import uploadImage from "../../../helpers/uploadImage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { validatePhoneWithCountryCode } from "../../../utils/functions";
import ImageUpload from "../../ImageUpload";
import dummyImage from "../../../assets/images/global_icons/dummyimage.svg";
import { Button, Card } from "react-bootstrap";

const Profile = ({ imagePath, setImagePath, name, setName }) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [profile, setProfile] = useState({
    id: "",
    name: name,
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    profile_image: imagePath,
    country_phone: "",
    phone_number: "",
    city: "",
    country: "",
    state: "",
    address: "",
    job_title: "",
    // uuid: "",
    user_social_media: [
      { media_type: "facebook", url: "", placeholder: "facebook.com/" },
      { media_type: "twitter", url: "", placeholder: "twitter.com/" },
      { media_type: "linkdin", url: "", placeholder: "linkedin.com/" },
      { media_type: "dribble", url: "", placeholder: "dribbble.com/" },
      { media_type: "instagram", url: "", placeholder: "instagram.com/" },
      { media_type: "behance", url: "", placeholder: "behance.net/" },
    ],
  });

  const handleChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    setProfile({ ...profile, [name]: value });
  };

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const loadProfile = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      GET_USER,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      setName(data.name);
      setImagePath(data.profile_image);

      if (data.dob) {
        data.dob = new Date(data.dob);
      }

      if (!data.country_phone) data.country_phone = "";

      if (data.phone_number) {
        data.phone_number = `${data.country_phone}${data.phone_number}`;
      } else {
        // for handling null
        data.phone_number = "";
      }

      if (
        loggedUser.name != data.name ||
        loggedUser.email != data.email ||
        data.profile_image != loggedUser.profile_image ||
        data.active_nfc != loggedUser.active_nfc
      ) {
        let userData = { ...loggedUser };
        userData.name = data.name;
        userData.email = data.email;
        userData.first_name = data.first_name;
        userData.last_name = data.last_name;
        userData.profile_image = data.profile_image;
        userData.active_nfc = data.active_nfc;
        setLoggedUser(userData);
      }
      setProfile(data);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const validateForm = () => {
    let newErrors = ValidateSchema(profile, ProfileSchema);

    setErrors(newErrors);

    if (Object.keys(newErrors).length) return false;

    if (profile.phone_number.length > profile.country_phone) {
      let resultPhone = validatePhoneWithCountryCode(
        profile.country_phone,
        profile.phone_number
      );
      if (resultPhone) {
        setErrors({
          phone_number: resultPhone,
        });
        return false;
      }
    }
    return true;
  };

  const handleDateChange = (e) => {
    setProfile({ ...profile, dob: e });
  };

  const handleSubmit = async (e) => {
    if (!validateForm()) return;
    setLoading(true);

    profile.user_social_media.map((ele) => {
      ["updated_at", "created_at", "placeholder"].forEach((e) => delete ele[e]);
    });

    let newDob = profile.dob;
    if (profile.dob) {
      newDob = `${
        newDob.getMonth() + 1
      }/${newDob.getDate()}/${newDob.getFullYear()}`;
    }

    let payload = { ...profile };

    payload.profile_image = imagePath;
    payload.dob = newDob;

    if (payload.phone_number && payload.country_phone.length > 0) {
      payload.phone_number = payload.phone_number.slice(
        payload.country_phone.length,
        payload.phone_number.length
      );
    } else {
      payload.country_phone = "";
    }

    if (payload.profile_image && typeof payload.profile_image == "object") {
      const { status, message, data } = await uploadImage(
        "profile",
        payload.profile_image,
        loggedUser?.token
      );

      if (status) {
        payload.profile_image = data;
      } else {
        showToast(status, message);
        setLoading(false);
        return;
      }
    }

    let { status, message, data } = await post(
      `${SETTING}/profile`,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (
      loggedUser.name != data.name ||
      loggedUser.email != data.email ||
      data.profile_image != loggedUser.profile_image
    ) {
      let userData = { ...loggedUser };
      userData.name = data.name;
      userData.email = data.email;
      userData.first_name = data.first_name;
      userData.last_name = data.last_name;
      userData.profile_image = data.profile_image;
      setLoggedUser(userData);
    }

    setName(data.name);

    showToast(status, message);

    setLoading(false);
  };

  useEffect(() => {
    loadProfile();
  }, []);

  // const generateQrCodeData = () => {
  //   const data = {
  //     // name: profile.name,
  //     // email: profile.email,
  //     // phone_number: profile.phone_number,

  //     id: profile.id,
  //     name: profile.name,
  //     dob: profile.dob,
  //     gender: profile.gender,
  //     profile_image: imagePath,
  //     country_phone: profile.country_phone,
  //     phone_number: profile.phone_number,
  //     city: profile.city,
  //     country: profile.country,
  //     state: profile.state,
  //     address: profile.address,
  //     job_title: profile.job_title,
  //     uuid: profile.uuid,
  //   };
  //   setQrCodeData(data);
  //   setQrModalOpen(true);
  // };
  return (
    <>
      {!loading ? (
        <Card className="bioDataWrapper">
          <Card.Body>
            <h4 className="mb-4">Account Info</h4>
            <div className="imageWrapper">
              <div className="position-relative mb-3">
                <div className="form-group mb-0">
                  <label>
                    Profile Image{" "}
                    <small>(Image must be PNG, JPG JPEG or GIF format)</small>
                  </label>
                </div>
                <ImageUpload
                  imageLink={true}
                  imageUrl={imagePath}
                  setPath={setImagePath}
                  imageType="profile"
                  dummyImage={dummyImage}
                />
                {/* <div className={classes.qrCode} onClick={handleQrOpen}>
                <img src={qrcode} alt="" />
              </div> */}
              </div>
              {/* <div>
              <h6 className="m-3">{name}</h6>
            </div> */}
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="First name"
                  type="text"
                  placeholder="First Name"
                  name="first_name"
                  value={profile.first_name}
                  handleChange={handleChange}
                  // icon={person}
                  error={errors.first_name}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="Last name"
                  type="text"
                  placeholder="Last Name"
                  name="last_name"
                  value={profile.last_name}
                  handleChange={handleChange}
                  // icon={person}
                  error={errors.last_name}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="Email"
                  type="text"
                  placeholder="Email"
                  name="email"
                  value={profile.email}
                  handleChange={handleChange}
                  // icon={emailicon}
                  error={errors.email}
                  disabled
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="input-group form-group">
                  <label className="label">Contact Number</label>
                  <PhoneInput
                    country="us"
                    enableSearch
                    countryCodeEditable={false}
                    inputClass={
                      errors.phone_number
                        ? "phoneNumberInput errorInput w-100 form-control"
                        : "phoneNumberInput w-100 form-control"
                    }
                    value={profile.phone_number}
                    onChange={(value, country) => {
                      setProfile({
                        ...profile,
                        phone_number: value,
                        country_phone: country.dialCode,
                      });
                    }}
                  />
                </div>
                <div className="text-danger small mt-1">
                  {errors.phone_number}
                </div>
              </div>

              <div className="col-12 col-md-8 col-lg-8">
                <SettingsInput
                  label="Address"
                  type="text"
                  placeholder="Address"
                  name="address"
                  value={profile.address}
                  handleChange={handleChange}
                  // icon={location}
                  error={errors.address}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="City"
                  type="text"
                  placeholder="City"
                  name="city"
                  value={profile.city}
                  handleChange={handleChange}
                  // icon={location}
                  error={errors.city}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="State"
                  type="text"
                  placeholder="State"
                  name="state"
                  value={profile.state}
                  handleChange={handleChange}
                  // icon={location}
                  error={errors.state}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="Country"
                  type="text"
                  placeholder="Country"
                  name="country"
                  value={profile.country}
                  handleChange={handleChange}
                  // icon={location}
                  error={errors.country}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="form-group">
                  <label className="label">Date of Birth</label>
                  <DatePicker
                    selected={profile.dob}
                    onChange={handleDateChange}
                    dateFormat="MM/dd/yyyy"
                    className="dobInput profile form-control"
                    placeholderText="MM/dd/yyyy"
                    showYearDropdown
                    isClearable
                    maxDate={new Date()} // allow up to today
                    excludeDates={[new Date()]} // but disable today
                    yearDropdownItemNumber={110}
                    scrollableYearDropdown
                  />
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <div className="selectWrapper">
                  <div className="form-group">
                    <label className="label">Gender</label>
                    <select
                      className="form-select customSelect form-control"
                      name="gender"
                      value={profile.gender}
                      onChange={handleChange}
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Prefer not to say</option>
                    </select>
                  </div>
                  <span className="errorText">{errors.gender}</span>
                </div>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <SettingsInput
                  label="Job, Position"
                  type="text"
                  placeholder="Photographer"
                  name="job_title"
                  value={profile.job_title}
                  handleChange={handleChange}
                  // icon={jobIcon}
                  error={errors.job_title}
                />
              </div>
            </div>
            <Button
              type="button"
              variant="primary"
              onClick={handleSubmit}
              className="mt-2"
            >
              Update Profile
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Profile;
